import axios from "axios";

const username = "SQL01UAT";
const password = "btR/RLAB95C2XR9pxSYnaQ==";

// login vs Domain
export const POST_TOKEN_DOAMAIN = (Url, Body, handleData) => {
  axios
    .post(Url, Body, {
      auth: {
        username: username,
        password: password,
      },
    })
    .then((res) => {
      handleData(res.data);
    })
    .catch(function (error) {
      if (error.response) {
        handleData({ Status: error.response });
      }
    });
};

//
export const POST_DATA_NOTOKEN_MYAPI = (Url, Data, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};

export const GET_TOKEN_MYAPI = (Url, Data, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};
export const GET_TOKEN_MYAPI_RECAPTCHA = (
  Url,
  RecaptchaToken,
  Data,
  HandleDate
) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
        "X-Recaptcha-Token-v3": RecaptchaToken.token_v3,
        "X-Recaptcha-Token-v2": RecaptchaToken.token_v2,
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};
export const POST_MYAPI = (Url, Data, Token, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};

export const POST_MYAPI_UPLOAD_FILE = (Url, Data, Token, HandleDate) => {
  axios
    .post(Url, Data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Token}`,
      },
    })
    .then((res) => {
      HandleDate(res.data);
    })
    .catch(function (error) {
      HandleDate({ Status: error.response });
    });
};

export const GET_MYAPI_TOKEN = (url, token, handleData) => {
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      handleData({ Status: "success", Response: res });
    })
    .catch(function (error) {
      handleData({ Status: "fail", Response: error.response });
    });
};
export const GET_MYAPI_NOT_TOKEN = (url, handleData) => {
  axios
    .get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      handleData({ Status: "success", Response: res });
    })
    .catch(function (error) {
      handleData({ Status: "fail", Response: error.response });
    });
};
